module.exports = __webpack_public_path__ + "img/qr.1f2567b4.svg";